<template>
  <v-container
    fluid
    grid-list-xl
    role="search"
    aria-label="Search Section"
  >
    <v-layout
      wrap
      align-center
      justify-center
    >
      <v-flex
        :class="{
          'xs12 sm12 md12 lg12': $vuetify.breakpoint.mdAndDown,
          'xs10 sm10 md10 lg10': $vuetify.breakpoint.lgAndUp
        }"
      >
        <v-card>
          <v-flex
            xs12
            sm12
            md12
            lg12
            align-center
            text-center
            justify-center
          >
            <v-select
              :items="charactersList"
              item-text="name"
              item-value="char_oid"
              color="accent"
              prepend-icon="fad fa-helmet-battle"
              :label="$t('components.selectUserChar.form.receiver') + ' *'"
              name="character-select"
              :aria-label="$t('components.selectUserChar.form.receiver')"
              aria-required="true"
              :aria-invalid="!selectedChar"
              autocomplete="off"
              @input="selectChar"
            />

            <v-progress-linear
              v-show="isLoading"
              color="accent"
              indeterminate
              aria-label="Loading characters"
              aria-live="polite"
            />
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "SelectUserCharacter",
  emits: {'selectedChar': null},
  data() {
    return {
        charactersList: [],
        isLoading: false
    }
  },
  beforeMount() {
    this.getCharacters();
  },
  methods: {
    getCharacters() {
      this.$api
        .getCurrentUserGameChars()
        .then(res => {
          this.isLoading = false;
          this.charactersList = res;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /**
     * Select the character
     * @param charId int - Char ID
     */
    selectChar(charId) {
      // Emit the selected char event with value of char id
      this.$emit("selectedChar", charId);
    }
  }
};
</script>
